<template>
  <div class="home">
    <div class="welcome">欢迎您提供问题线索！</div>
    <div class="info">
      <span>线索征集单位：{{ enterprise }}</span>
      <span>联系方式：{{ mobile }}</span>
    </div>
    <Form ref="formValidate" :model="formItem" :rules="ruleValidate" :label-width="80">
      <FormItem label="问题类型" prop="type">
        <CheckboxGroup v-model="formItem.type">
          <Checkbox label="1">食药安全</Checkbox>
          <Checkbox label="2">假冒伪劣</Checkbox>
          <Checkbox label="3">破坏环境</Checkbox>
          <Checkbox label="4">其它</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="线索信息" prop="message">
        <div class="input-with-counter">
          <Input v-model="formItem.message" type="textarea" :rows="4" maxlength="100" />
          <span class="char-counter">{{ formItem.message.length }}/100</span>
        </div>
      </FormItem>
      <FormItem label="证明材料" prop="imageList">
        <div class="demo-upload-list" v-for="item in formItem.imageList" :key="item.uid">
          <template v-if="item.status === 'finished'">
            <Image :src="item.url" fit="contain" width="100%" height="100%" @click="handleView(item.url)" />
            <div class="demo-upload-delete">
              <Icon type="ios-close-circle" @click="handleRemove(item)" />
            </div>
          </template>
          <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info />
          </template>
        </div>
        <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess"
                :format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag"
                :action="upload()" style="display: inline-block;width:58px;margin-top: 2px;">
          <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20" />
          </div>
        </Upload>
        <ImagePreview v-model="visible" :preview-list="[bigImage]" />
      </FormItem>
      <FormItem label="意见建议" prop="advice">
        <div class="input-with-counter">
          <Input v-model="formItem.advice" type="textarea" :rows="4" maxlength="200" />
          <span class="char-counter">{{ formItem.advice.length }}/200</span>
        </div>
      </FormItem>
      <FormItem label="您的姓名" prop="name">
        <div class="input-with-counter">
          <Input v-model="formItem.name" maxlength="20" />
          <span class="char-counter">{{ formItem.name.length }}/20</span>
        </div>
      </FormItem>
      <FormItem label="联系方式" prop="mobile">
        <div class="input-with-counter">
          <Input v-model="formItem.mobile" maxlength="20" />
          <span class="char-counter">{{ formItem.mobile.length }}/20</span>
        </div>
      </FormItem>
      <FormItem>
        <Button type="primary" :loading="loading" @click="handleSubmit">提交</Button>
        <Button @click="handleReset" style="margin-left: 8px">重置</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'HomeView',
  data() {
    return {
      formItem: {
        type: [],
        message: '',
        imageList: [],
        advice: '',
        deptId: 0,
        name: '',
        mobile: ''
      },
      ruleValidate: {
        type: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择问题类型',
          trigger: 'change'
        }],
        message: [{
          required: true,
          message: '请输入线索信息',
          trigger: 'blur'
        }]
      },
      defaultList: [],
      bigImage: '',
      visible: false,
      loading: false,
      enterprise: '',
      mobile: '',
      VUE_APP_API_URL: process.env.VUE_APP_API_URL
    }
  },
  created() {
    this.deptId = this.$route.params.deptId
    axios.post(`${this.VUE_APP_API_URL}/open/enterprise`, { deptId: this.deptId })
      .then((response) => {
        if (response.data.code === 200) {
          this.enterprise = response.data.data?.dept_name
          this.mobile = response.data.data?.phone
        }
      })
  },
  methods: {
    handleView(url) {
      this.bigImage = url
      this.visible = true
    },
    handleRemove(file) {
      this.formItem.imageList.splice(this.formItem.imageList.indexOf(file), 1)
      this.$refs.upload.fileList.splice(this.$refs.upload.fileList.indexOf(file), 1)
    },
    handleSuccess(res, file) {
      file.url = res.data.url
      this.formItem.imageList = [...this.$refs.upload.fileList]
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '格式不正确',
        desc: `图片 ${file.name} 格式不正确, 请重新上传 jpg 或者 png`
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '超过大小限制',
        desc: `图片  ${file.name} 太大了, 不能超过2M`
      })
    },
    handleBeforeUpload() {
      const check = this.formItem.imageList.length < 2
      if (!check) {
        this.$Notice.warning({
          title: '最多只能上传2张图片'
        })
      }
      return check
    },
    handleSubmit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.loading = true
          const imageArr = []
          this.formItem.imageList.forEach((item) => {
            imageArr.push(item.url)
          })
          axios.post(`${this.VUE_APP_API_URL}/open/clue`, {
            type: this.formItem.type.join(','),
            message: this.formItem.message,
            imageList: imageArr.join(','),
            advice: this.formItem.advice,
            name: this.formItem.name,
            mobile: this.formItem.mobile,
            deptId: this.deptId
          })
            .then((response) => {
              this.loading = false
              if (response.data.code === 200) {
                this.$Message.info({
                  background: true,
                  duration: 3,
                  content: '感谢您提供线索！'
                })
                this.handleReset()
              } else {
                this.$Message.error({
                  background: true,
                  content: '网络错误，请稍后重试！'
                })
              }
            })
            .catch((error) => {
              this.$Message.error({
                background: true,
                content: `网络错误，${error}`
              })
            })
        } else {
          this.$Message.error('请检查必填项！')
        }
      })
    },
    handleReset() {
      this.formItem.imageList = []
      this.$refs.upload.clearFiles()
      this.$refs.formValidate.resetFields()
    },
    upload() {
      return `${this.VUE_APP_API_URL}/common/upload`
    }
  },
  mounted() {
    this.formItem.imageList = this.$refs.upload.fileList
  }
}
</script>
<style lang="less" scoped>
.home {
  padding: 20px;

  .welcome {
    font-size: 18px;
    text-align: center;
  }

  .info {
    font-size: 14px;
    text-align: center;
    margin: 20px 0;

    span:last-child {
      margin-left: 10px;
    }
  }

  .demo-upload-list {
    display: inline-block;
    vertical-align: top;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    margin: 0 10px 10px 0;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-delete {
    position: absolute;
    top: -25px;
    right: -10px;
    z-index: 10;
  }

  .demo-upload-delete i {
    color: #ed4014;
    font-size: 20px;
    cursor: pointer;
  }

  .input-with-counter {
    position: relative;

    .char-counter {
      display: inline-block;
      font-size: 12px;
      color: #666;
      margin-top: 4px;
      float: right;
    }
  }
}
</style>
